var _rect, _rect2, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCogwheelOptionMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1100,
    transform: "translate(-1157 -101)",
    fill: "#F5F6FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_20447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-32 -17.9023C-32 -23.4252 -27.5228 -27.9023 -22 -27.9023H67.1696L81.8645 -42L95.6636 -27.9023H183C188.523 -27.9023 193 -23.4252 193 -17.9023V155C193 160.523 188.523 165 183 165H-22C-27.5228 165 -32 160.523 -32 155V-17.9023Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#4FC3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6276 10.9999C15.6276 11.204 15.609 11.3959 15.5844 11.588L16.886 12.578C17.0031 12.668 17.034 12.8299 16.9599 12.9619L15.7263 15.0379C15.6524 15.1699 15.4919 15.2239 15.35 15.1699L13.8141 14.57C13.4934 14.804 13.1481 15.008 12.7718 15.158L12.5374 16.7479C12.5188 16.8919 12.3893 17 12.235 17H9.76763C9.61347 17 9.48397 16.8919 9.46539 16.7479L9.23109 15.158C8.85479 15.008 8.50937 14.8099 8.18863 14.57L6.6527 15.1699C6.517 15.2179 6.35044 15.1699 6.2764 15.0379L5.04281 12.9619C4.96878 12.8299 4.99955 12.668 5.11675 12.578L6.41829 11.588C6.3936 11.3959 6.37513 11.1979 6.37513 10.9999C6.37513 10.802 6.3936 10.604 6.41829 10.4119L5.11675 9.42193C4.99955 9.33193 4.96258 9.16992 5.04281 9.03793L6.27639 6.96192C6.35044 6.82994 6.5108 6.776 6.65268 6.82994L8.18862 7.43C8.50937 7.19595 8.85477 6.99195 9.23107 6.84198L9.46537 5.25192C9.48395 5.10798 9.61344 5 9.76761 5H12.235C12.3893 5 12.5188 5.10798 12.5373 5.25192L12.7718 6.84197C13.1481 6.99194 13.4934 7.18992 13.8141 7.42998L15.35 6.82992C15.4857 6.78191 15.6524 6.82992 15.7263 6.96191L16.9599 9.03793C17.034 9.16992 17.003 9.33193 16.886 9.42193L15.5844 10.4119C15.609 10.604 15.6276 10.7959 15.6276 10.9999ZM8.8178 11.0001C8.8178 12.2032 9.79648 13.1819 10.9996 13.1819C12.2027 13.1819 13.1814 12.2032 13.1814 11.0001C13.1814 9.79692 12.2027 8.81822 10.9996 8.81822C9.79648 8.81822 8.8178 9.79692 8.8178 11.0001Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_20447",
    x: -62,
    y: -68,
    width: 285,
    height: 267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_20447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_20447",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogwheelOptionMenu);
export default __webpack_public_path__ + "static/media/cogwheel-option-menu.58cd34057a3ab597a5a9a4a88330f010.svg";
export { ForwardRef as ReactComponent };